import { ComboBox as ComboBoxComponent } from "./ComboBox";

export const ComboBox = Object.assign(ComboBoxComponent, {});

export type { IComboBoxEmptyStateProps } from "./EmptyState";